// @flow
import React from 'react'

type Props = {
  prNumber: string,
  prTitle: string,
  href: string,
  author: string,
  timeAgo: string
}

const PRTitle = (props: Props): React$Element<'div'> => <div className='flex-row'
  style={{
    color: '#24384e',
    fontFamily: 'Lato'
  }}>
  <a href={props.href} target='_blank' style={{fontSize: '18px'}}>
    <span style={{
      color: 'black',
      textOverflow: 'ellipsis',
      fontWeight: 'bold'
    }}>
      {props.prTitle}
    </span>
    <span style={{
      color: 'gray',
      marginLeft: 5
    }}>
      #{props.prNumber}
    </span>
  </a>
  {props.timeAgo && props.author
    ? <span style={{marginLeft: 'auto'}}>last updated:&nbsp;
      <strong>{props.timeAgo}&nbsp;ago&nbsp;</strong>
      by
      <strong>&nbsp;{props.author}</strong>
    </span>
    : null
  }
</div>

export default PRTitle



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/PRList/PRListItem/Title.js